import { wrapGql } from "../_"

export default (a: NuxtAxiosInstance) => ({
  listPCRPlace: () => wrapGql(
    a.$post("/graphql", {
      query: /* gql */ `
        query {
          listPCRPlace(limit: 999) {
            items {
              id
              place {
                current
              }
              address {
                current
              }
              startDate
              startTime
              finishDate
              finishTime
            }
          }
        }
      `,
    }),
  ),
})
